var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6951 2.20711C18.0856 1.81658 18.0856 1.18342 17.6951 0.792894C17.3046 0.40237 16.6714 0.402368 16.2809 0.792891L14.3422 2.73163L14.0603 2.44974C13.6698 2.05922 13.0366 2.05922 12.6461 2.44974C12.2555 2.84026 12.2555 3.47343 12.6461 3.86395L13.6351 4.85295C14.0256 5.24347 14.6587 5.24347 15.0493 4.85295L17.6951 2.20711Z",
    fill: "#0F973D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 5.00001C10.999 7.20915 9.20816 9.00001 6.99902 9.00001C4.78988 9.00001 2.99902 7.20915 2.99902 5.00001C2.99902 2.79088 4.78988 1.00002 6.99902 1.00002C9.20816 1.00002 10.999 2.79088 10.999 5.00001Z",
    fill: "#0F973D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 20C4.13176 20 -1.35192 18.6701 0.304676 16C1.55045 13.9921 4.07025 12 6.99902 12C9.92779 12 12.4476 13.9921 13.6934 16C15.35 18.6701 9.86628 20 6.99902 20Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep5);
export default __webpack_public_path__ + "static/media/ic_step5.721ca4c35469030b91db008fcccd479d.svg";
export { ForwardRef as ReactComponent };